import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import ISite from '../../../../../_interfaces/ISite';
import { CustomersService } from '../../../../../_services/customers/customers.service';
import { DataService } from '../../../../../_services/data/data.service';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { FilesService } from '../../../../../_services/files/files.service';
import { SessionService } from '../../../../../_services/session/session.service';
import { BaseComponent } from '../../../../../components/base/base.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { AdminFormActionsComponent } from '../../../../../components/admin-ui/admin-form-actions/admin-form-actions.component';

@Component({
  standalone: true,
  selector: 'app-export-patients',
  templateUrl: './export-patients.component.html',
  styleUrls: ['./export-patients.component.scss'],
  imports: [
    TranslatePipe,

    MultiSelectModule,
    FormsModule,
    ButtonModule,
    CommonModule,
    AdminFormActionsComponent,
  ],
})
export class ExportPatientsComponent extends BaseComponent {
  sites: ISite[] = [];
  selectedSites: ISite[] = [];
  startDate: Date;
  endDate: Date;
  locale: string;
  exporting = false;
  constructor(
    private customerService: CustomersService,
    private dataService: DataService,
    private messageService: MessageService,
    public session: SessionService,
    private translate: TranslateService,
    private filesService: FilesService
  ) {
    super(session);
  }

  private getCustomerSites() {
    if (!this.customer?.id) {
      this.sites = [];
      return;
    }

    this.customerService
      .getSites(this.customer.id)
      .subscribe((sites: ISite[]) => {
        this.sites = sites;
      });
  }

  exportData() {
    if (this.exporting || !this.customer?.id || !this.selectedSites?.length) {
      return;
    }

    const exportedSites = this.selectedSites.map((x) => x.id);
    this.exporting = true;
    this.dataService
      .exportDataPatients(this.customer.id, {
        sites: exportedSites,
      })
      .subscribe({
        next: (data: any) => {
          const fecha = moment().format('YYYY-MM-DD_HH:mm');
          const filename = `${this.customer.name}_patients_${fecha}`;
          this.filesService.generateExcel(filename, data);
          this.exporting = false;
        },
        error: () => {
          this.messageService.add({
            summary: this.translate.instant(
              'MESSAGES.DATA.ERROR.EXPORT.SUMMARY'
            ),
            detail: this.translate.instant('MESSAGES.DATA.ERROR.EXPORT.DETAIL'),
            severity: 'error',
          });
          this.exporting = false;
        },
      });
  }

  ngOnInit() {
    super.ngOnInit();
    this.locale = this.translate.currentLang;
    this.selectedSites = [];
    this.getCustomerSites();
  }
}
